import { render, staticRenderFns } from "./TeachingOverviewPage.vue?vue&type=template&id=08c38233"
import script from "./TeachingOverviewPage.vue?vue&type=script&lang=js"
export * from "./TeachingOverviewPage.vue?vue&type=script&lang=js"
import style0 from "./TeachingOverviewPage.vue?vue&type=style&index=0&id=08c38233&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports